import * as React from "react";
import { IParagraphMediaCtaProps } from "./ParagraphMediaCtaProps";
import { Container } from "./ParagraphMediaCtaHelpers";
import { graphql } from "gatsby";
import MediaCta from "../../common/MediaCta/MediaCta";

const ParagraphMediaCta: React.FC<IParagraphMediaCtaProps> = (props) => {
  return (
    <Container>
      <MediaCta {...props} />
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphMediaCta on paragraph__media_cta {
    id
    parent_type
    relationships {
      field_sites {
        machine_name
      }
      field_media {
        field_title
        field_description
        field_link {
          url
          title
        }
        field_learn_more_link {
          url
          title
        }
        relationships {
          field_logo {
            relationships {
              field_media_file {
                publicUrl
              }
            }
          }
          desktopImage: field_media_image {
            publicUrl
            gatsbyImage(
              width: 1110
              height: 240
              placeholder: BLURRED
              layout: FIXED
              formats: [AUTO, WEBP]
            )
          }
          mobileImage: field_media_image {
            publicUrl
            gatsbyImage(
              width: 490
              height: 200
              placeholder: BLURRED
              layout: FIXED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
  }
`;
export default ParagraphMediaCta;
